import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
  user: {
    id: string;
    displayName: string | null;
    emailVerified: boolean;
  } | null;
}

const initialState: UserState = {
  user: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<{ id: string; displayName: string | null; emailVerified: boolean }>) => {
      state.user = action.payload;
    },
    logoutSuccess: (state, action: PayloadAction) => {
      state.user = null;
    },
  },
});

export const { loginSuccess, logoutSuccess } = userSlice.actions;

export default userSlice.reducer;
